/** @format */
import React, {useState} from 'react';
import SuperAgent from 'superagent';

export const useSavePaymentProfile = formData => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState(null);

    const handleSavePaymentProfile = () => {
        setLoading(true);

        const url = '/account/users/save-nonce-payment-profile';

        SuperAgent.post(url)
            .set('Accept', 'application/json')
            .send(formData)
            .end((err, response) => {
                setLoading(false);
                if (err || !response.body) {
                    setError(err.message ?? String(err));
                    setData(null);
                } else {
                    setData(response);
                    setError('');
                }
            });
    };

    return {
        handleSavePaymentProfile,
        loading,
        data,
        error
    };
};
